<template>
	<Layout :pageTitle="'Ingresar'" class="">
		<div class="container">
			<div class="row row-xs mt-5 pb-5">
				<div class="col-12 mt-4 mb-5 justify-content-center">
					<div class="form-box" v-if="!sended">
						<h3 class="mt-3">{{ $t("title") }}</h3>
						<p class="p-2">{{ $t("subtitle") }}</p>
						<FormulateForm v-model="form" ref="form" class="p-2" @submit="submit">
							<FormulateInput
								:label="$t('email')"
								name="email"
								type="email"
								validation="email"
								class="mb-3"
							/>

							<div class="alert alert-danger p-2" v-if="error">
								{{ $t("errorText", { email: form.email }) }}
							</div>

							<div class="form-group d-flex justify-content-end mb-0">
								<button class="btn btn-primary btn-block" type="submit" :disabled="loading">
									<span v-if="loading">{{ $t("sending") }}...</span>
									<span v-if="!loading">{{ $t("button") }}</span>
								</button>
							</div>
						</FormulateForm>
					</div>
					<div class="form-box" v-if="sended">
						<h3 class="mt-3">{{ $t("sended") }}</h3>
						<p>{{ $t("sendedText") }}</p>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"

export default {
	name: "PasswordForgot",
	components: {
		Layout
	},
	data() {
		return {
			loading: false,
			sended: false,
			error: false,
			form: {}
		}
	},
	methods: {
		submit() {
			if (!this.loading) {
				this.loading = true
				this.error = false
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($email: String!) {
								userPasswordForgot(email: $email)
							}
						`,
						variables: {
							email: this.form.email
						}
					})
					.then((data) => {
						console.log(data)
						this.loading = false
						this.sended = true
					})
					.catch(() => {
						this.error = true
						this.loading = false
					})
			}
		}
	},
	i18n: {
		messages: {
			es: {
				title: "¿Olvistaste tu contraseña?",
				subtitle:
					"Ingrese su dirección de correo electrónico y le enviaremos un enlace para establecer una nueva contraseña",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sendedText:
					"Le hemos enviado un correo electrónico con un enlace para que pueda restablecer su contraseña.",
				errorText: "No existe un usuario con el email: {email}",
				email: "Email"
			},
			en: {
				title: "Forgot your password?",
				subtitle:
					"Please enter your email address and you will receive an email that contains a link to set a new password",
				button: "Reset my password",
				sended: "Done!",
				sendedText: "We have sent a link to your email so that you can reset your password.",
				errorText: "No user found for email: {email}",
				email: "Email"
			},
			pt: {
				title: "Esqueceu sua senha?",
				subtitle:
					"Inglês su dirección de correo eletrônico y le enviaremos un enlace para estabelecer una nueva contraseña",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sendedText:
					"O hemos enviado un correo eletrônico con un enlace para que pueda restablecer su contraseña.",
				errorText: "Nenhum usuario encontrado para e-mail: {email}",
				email: "Email"
			}
		}
	}
}
</script>

<style scoped>
.form-box {
	margin: auto;
	flex-grow: 1;
	padding: 2rem 2rem;
	max-width: 400px;
}
</style>
